/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@mui/material';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../redux/store';
import { GroupDisplay, groupRowItems } from './groupRowItems';

const InfoDataList = ({ data }: { data: any }) => {
 const structure = useSelector((state: RootState) => state.results.structure);
 //  console.log(groupRowItems(structure, data));
 const a = useMemo(() => groupRowItems(structure, data), [structure, data]);

 return (
  <Box>
   <GroupDisplay data={a} />
  </Box>
 );
};
export default InfoDataList;
